import { render, staticRenderFns } from "./DeviceTele2.vue?vue&type=template&id=a27a7516&scoped=true&"
import script from "./DeviceTele2.vue?vue&type=script&lang=js&"
export * from "./DeviceTele2.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTele2.vue?vue&type=style&index=0&id=a27a7516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27a7516",
  null
  
)

export default component.exports